import React, { Component, Fragment } from 'react';
import { OpenPositionsTable } from './OpenPositionsTable';
import { ClosedPositionsTable } from './ClosedPositionsTable';
import { PositionStatusPanel } from './PositionStatusPanel';

export class PositionsView extends Component {
    render() {
        return (
            <Fragment>
                <PositionStatusPanel />
                <OpenPositionsTable />
                <ClosedPositionsTable />
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/index.js